import FlashProgressBar from "./FlashProgressBar";
import SystemDesktopTopBarLayout from "../../../layouts/SystemDesktopTopBarLayout";
import SystemFlashTopBarLogoLayout from "../../../layouts/SystemFlashTopBarLogoLayout";
import SystemFlashLogoImage from "../../../images/SystemFlashLogoImage";
import SystemFlashSelectedGradeBadge from "../../../badges/SystemFlashSelectedGradeBadge";
import SystemDesktopTabletLeaveFlashButton from "../../../buttons/SystemDesktopTabletLeaveFlashButton";
import {FlashLogoTextSize} from "../../../../controllers/SystemFlashLogoTextController";

export default function FlashDesktopTopBar({ onLeaveFlashPressed,
                                             selectedGrade,
                                             currentQuestion,
                                             totalQuestion }) {
    // Used in MetaFlashScreen to display top bar
    // in mobile mode

    // BUILD
    return (
        <SystemDesktopTopBarLayout>
            <SystemFlashTopBarLogoLayout>
                <SystemFlashLogoImage flashLogoSize={FlashLogoTextSize.XSMALL} />
                <SystemFlashSelectedGradeBadge selectedGrade={selectedGrade} />
            </SystemFlashTopBarLogoLayout>
            <FlashProgressBar currentQuestion={currentQuestion}
                              totalQuestion={totalQuestion} />
            <SystemDesktopTabletLeaveFlashButton onLeaveFlashPressed={onLeaveFlashPressed} />
        </SystemDesktopTopBarLayout>
    );
}